import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import IceButton from "../../components/Button";

export default function DialogComment(props: any) {
    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)
    let {open, setOpen, keyDataSet, comment, setMapInfo} = props

    const [comText, setComText] = useState<any>(comment)

    useEffect(() => {
        setComText(comment)
    }, [comment])

    function handleComText(event: any) {
        setComText(event.target.value)
        // console.log(event.target.value)
    }

    function handleSave() {

        fetch(`${serverIP}/commentmap/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({...keyDataSet, comText: comText, user: user.username}),
        }).then(res => res.json())
            .then((data) => {
                if (data.code === 200) {
                    setMapInfo((prev: any) => {
                        return {...prev, mapRemark: comText}
                    })
                }
            })

        setOpen(false)    // a dialog must be closed anyway after Save is clicked
    }

    return (

        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Mapping Comment</DialogTitle>

            <DialogContent>

                <DialogContentText style={{fontSize: '0.85rem'}}>
                    Provide any additional information, remark or a question regarding this mapping.
                </DialogContentText>

                <TextField
                    value={comText}
                    autoFocus
                    margin="dense"
                    id="name"
                    // label="Email Address"
                    type="text"
                    fullWidth
                    variant="standard"
                    multiline
                    minRows={2}
                    maxRows={4}
                    onChange={(event: any) => handleComText(event)}
                />
            </DialogContent>

            <DialogActions>
                <IceButton type="primary" text="Save" onclick={handleSave} />
                <IceButton type="secondary" text="Clear" onclick={() => setComText('')} />
                <IceButton type="delete" text="Cancel" onclick={() => setOpen(false)} />
            </DialogActions>

        </Dialog>
    );
}